// Store utilities and constants

// Stack colors - vibrant pink/purple/blue palette
export const STACK_COLORS = [
    { name: 'pink', label: 'Pink', class: 'bg-stack-pink', lightClass: 'bg-stack-pink-light' },
    { name: 'purple', label: 'Purple', class: 'bg-stack-purple', lightClass: 'bg-stack-purple-light' },
    { name: 'blue', label: 'Blue', class: 'bg-stack-blue', lightClass: 'bg-stack-blue-light' },
    { name: 'cyan', label: 'Cyan', class: 'bg-stack-cyan', lightClass: 'bg-stack-cyan-light' },
    { name: 'teal', label: 'Teal', class: 'bg-stack-teal', lightClass: 'bg-stack-teal-light' },
    { name: 'green', label: 'Green', class: 'bg-stack-green', lightClass: 'bg-stack-green-light' },
    { name: 'orange', label: 'Orange', class: 'bg-stack-orange', lightClass: 'bg-stack-orange-light' },
    { name: 'red', label: 'Red', class: 'bg-stack-red', lightClass: 'bg-stack-red-light' },
    { name: 'indigo', label: 'Indigo', class: 'bg-stack-indigo', lightClass: 'bg-stack-indigo-light' },
    { name: 'slate', label: 'Slate', class: 'bg-stack-slate', lightClass: 'bg-stack-slate-light' },
];

// Extended emoji icons for stacks
export const STACK_ICONS = [
    // Time-based
    { name: 'sun', emoji: '☀️', label: 'Morning' },
    { name: 'sunrise', emoji: '🌅', label: 'Sunrise' },
    { name: 'moon', emoji: '🌙', label: 'Night' },
    { name: 'stars', emoji: '✨', label: 'Evening' },
    
    // Health & Wellness
    { name: 'heart', emoji: '❤️', label: 'Health' },
    { name: 'sparkle-heart', emoji: '💖', label: 'Self-love' },
    { name: 'meditation', emoji: '🧘', label: 'Meditation' },
    { name: 'lotus', emoji: '🪷', label: 'Mindfulness' },
    { name: 'spa', emoji: '💆', label: 'Self-care' },
    { name: 'bath', emoji: '🛁', label: 'Relaxation' },
    
    // Fitness
    { name: 'fitness', emoji: '💪', label: 'Fitness' },
    { name: 'running', emoji: '🏃', label: 'Running' },
    { name: 'yoga', emoji: '🤸', label: 'Yoga' },
    { name: 'bike', emoji: '🚴', label: 'Cycling' },
    { name: 'swim', emoji: '🏊', label: 'Swimming' },
    
    // Mind & Learning
    { name: 'brain', emoji: '🧠', label: 'Focus' },
    { name: 'lightbulb', emoji: '💡', label: 'Ideas' },
    { name: 'book', emoji: '📖', label: 'Reading' },
    { name: 'books', emoji: '📚', label: 'Learning' },
    { name: 'pencil', emoji: '✏️', label: 'Writing' },
    { name: 'graduation', emoji: '🎓', label: 'Study' },
    
    // Work & Productivity
    { name: 'laptop', emoji: '💻', label: 'Work' },
    { name: 'briefcase', emoji: '💼', label: 'Business' },
    { name: 'target', emoji: '🎯', label: 'Goals' },
    { name: 'rocket', emoji: '🚀', label: 'Launch' },
    { name: 'chart', emoji: '📈', label: 'Progress' },
    { name: 'calendar', emoji: '📅', label: 'Planning' },
    
    // Home & Daily
    { name: 'home', emoji: '🏠', label: 'Home' },
    { name: 'bed', emoji: '🛏️', label: 'Sleep' },
    { name: 'alarm', emoji: '⏰', label: 'Wake up' },
    { name: 'shower', emoji: '🚿', label: 'Shower' },
    { name: 'toothbrush', emoji: '🪥', label: 'Hygiene' },
    { name: 'mirror', emoji: '🪞', label: 'Grooming' },
    
    // Food & Drink
    { name: 'coffee', emoji: '☕', label: 'Coffee' },
    { name: 'tea', emoji: '🍵', label: 'Tea' },
    { name: 'water', emoji: '💧', label: 'Hydration' },
    { name: 'salad', emoji: '🥗', label: 'Healthy eating' },
    { name: 'apple', emoji: '🍎', label: 'Nutrition' },
    { name: 'cooking', emoji: '🍳', label: 'Cooking' },
    
    // Nature & Outdoors
    { name: 'leaf', emoji: '🌿', label: 'Nature' },
    { name: 'flower', emoji: '🌸', label: 'Growth' },
    { name: 'tree', emoji: '🌳', label: 'Outdoors' },
    { name: 'sun-cloud', emoji: '⛅', label: 'Weather' },
    { name: 'rainbow', emoji: '🌈', label: 'Positivity' },
    
    // Social & Communication
    { name: 'speech', emoji: '💬', label: 'Communication' },
    { name: 'phone', emoji: '📱', label: 'Calls' },
    { name: 'mail', emoji: '📧', label: 'Email' },
    { name: 'handshake', emoji: '🤝', label: 'Networking' },
    { name: 'family', emoji: '👨‍👩‍👧', label: 'Family' },
    
    // Creative
    { name: 'art', emoji: '🎨', label: 'Creative' },
    { name: 'music', emoji: '🎵', label: 'Music' },
    { name: 'camera', emoji: '📷', label: 'Photography' },
    { name: 'guitar', emoji: '🎸', label: 'Practice' },
    { name: 'microphone', emoji: '🎤', label: 'Podcast' },
    
    // Finance
    { name: 'money', emoji: '💰', label: 'Finance' },
    { name: 'piggy', emoji: '🐷', label: 'Savings' },
    { name: 'receipt', emoji: '🧾', label: 'Budget' },
    
    // Misc
    { name: 'star', emoji: '⭐', label: 'Favorites' },
    { name: 'trophy', emoji: '🏆', label: 'Achievement' },
    { name: 'fire', emoji: '🔥', label: 'Motivation' },
    { name: 'check', emoji: '✅', label: 'Tasks' },
    { name: 'sparkles', emoji: '✨', label: 'Magic' },
    { name: 'gem', emoji: '💎', label: 'Premium' },
    { name: 'puzzle', emoji: '🧩', label: 'Problem-solving' },
    { name: 'game', emoji: '🎮', label: 'Gaming' },
    { name: 'dog', emoji: '🐶', label: 'Pet care' },
    { name: 'plant', emoji: '🪴', label: 'Plants' },
    { name: 'cleaning', emoji: '🧹', label: 'Cleaning' },
    { name: 'laundry', emoji: '🧵', label: 'Laundry' },
];

export const FREE_TIER_STACK_LIMIT = 10;

export function getTodayStr() {
    return new Date().toISOString().split('T')[0];
}

export function getCompletionsForDate(completions, stackId, dateStr) {
    return completions.filter(c => 
        c.stack_id === stackId && 
        c.completed_at.startsWith(dateStr)
    );
}

export function wasStackRan(completions, stackId, dateStr) {
    return getCompletionsForDate(completions, stackId, dateStr).length > 0;
}

export function calculateStreak(completions, stack) {
    let streak = 0;
    let graceUsed = 0;
    const today = new Date();
    const maxGrace = stack.grace_days || 1;
    
    for (let i = 0; i < 365; i++) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toISOString().split('T')[0];
        
        if (wasStackRan(completions, stack.id, dateStr)) {
            streak++;
            graceUsed = 0;
        } else {
            if (graceUsed < maxGrace && i > 0) {
                graceUsed++;
            } else {
                break;
            }
        }
    }
    
    return streak;
}

export function calculateBestStreak(completions, stack) {
    let bestStreak = 0;
    let currentStreak = 0;
    const maxGrace = stack.grace_days || 1;
    
    const dates = new Set();
    completions
        .filter(c => c.stack_id === stack.id)
        .forEach(c => dates.add(c.completed_at.split('T')[0]));
    
    const sortedDates = Array.from(dates).sort();
    
    if (sortedDates.length === 0) return 0;
    
    let lastDate = null;
    
    sortedDates.forEach(dateStr => {
        const date = new Date(dateStr);
        
        if (!lastDate) {
            currentStreak = 1;
        } else {
            const daysDiff = Math.floor((date - lastDate) / (24 * 60 * 60 * 1000));
            
            if (daysDiff === 1) {
                currentStreak++;
            } else if (daysDiff <= maxGrace + 1) {
                currentStreak++;
            } else {
                bestStreak = Math.max(bestStreak, currentStreak);
                currentStreak = 1;
            }
        }
        
        lastDate = date;
    });
    
    return Math.max(bestStreak, currentStreak);
}

export function get7DayHistory(completions, stack) {
    const history = [];
    const today = new Date();
    
    for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toISOString().split('T')[0];
        
        const dayCompletions = getCompletionsForDate(completions, stack.id, dateStr);
        const ran = dayCompletions.length > 0;
        
        history.push({
            date: dateStr,
            dayOfWeek: date.toLocaleDateString('en-US', { weekday: 'short' }).charAt(0),
            ran,
            itemsCompleted: dayCompletions.length,
            totalItems: stack.items.length,
            isToday: i === 0,
        });
    }
    
    return history;
}

export function getGreeting() {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    if (hour < 21) return 'Good evening';
    return 'Good night';
}

export function generateId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
